import AuthContainer from './features/Auth/AuthContainer';
import Animation from './features/Auth/components/Animation';
import './App.css';

function App() {
  return (
    <div className="App">
      <Animation />
      <AuthContainer />
    </div>
  );
}

export default App;
